import { useEffect, useState } from 'react';

import debounce from '@/utils/debounce';

export enum BreakPoints {
  xxs = '(min-width: 0px)',
  xxsMax = '(max-width: 479px)',
  xs = '(min-width: 480px)',
  xsMax = '(max-width: 575px)',
  sm = '(min-width: 576px)',
  smMax = '(max-width: 767px)',
  md = '(min-width: 768px)',
  mdMax = '(max-width: 991px)',
  lg = '(min-width: 992px)',
  lgMax = '(max-width: 1199px)',
  xl = '(min-width: 1200px)',
  xlMax = '(max-width: 1439px)',
  xxl = '(min-width: 1440px)',
  xxlMax = '(max-width: 1599px)',
  xxxl = '(min-width: 1600px)',
}

const useMatchMedia = (mediaString: BreakPoints) => {
  const [match, setMatch] = useState<boolean>();

  useEffect(() => {
    const media = window.matchMedia(mediaString);
    setMatch(media.matches);
    const resizeHandler = debounce((_: Event) => {
      const media = window.matchMedia(mediaString);
      setMatch(media.matches);
    }, 200);

    window.addEventListener('resize', resizeHandler);

    return () => window.removeEventListener('resize', resizeHandler);
  }, [mediaString]);

  return match;
};

export default useMatchMedia;
